// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3f8768b","867":"bca7bed5"}[chunkId] + ".chunk.js";
};